import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import type { Item } from "../lib/types";

export function StockBadge({ item }: { item: Item }) {
  if (!item.quantity_verified) return <span className="stock-badge unknown">À vérifier</span>;
  const tone = item.current_quantity <= 0 ? "out" : item.current_quantity <= item.alert_threshold ? "low" : "ok";
  return <span className={`stock-badge ${tone}`}><strong>{item.current_quantity}</strong> en stock</span>;
}

export function Notice({ children, tone = "info" }: { children: ReactNode; tone?: "info" | "success" | "warning" | "error" }) {
  return <div className={`notice ${tone}`} role={tone === "error" ? "alert" : "status"}>{children}</div>;
}

export function PageHeading({ eyebrow, title, description, action }: { eyebrow: string; title: string; description?: string; action?: ReactNode }) {
  return <section className="page-heading"><div><p className="eyebrow">{eyebrow}</p><h1>{title}</h1>{description && <p className="subheading">{description}</p>}</div>{action}</section>;
}

export function BackLink({ to = "/", children = "Retour à l’inventaire" }: { to?: string; children?: ReactNode }) {
  return <Link className="back-link" to={to}>← {children}</Link>;
}

export function LoadingBlock() { return <div className="empty-state large"><span className="spinner" /><span>Chargement…</span></div>; }

export function formatDate(value: string | null, includeTime = false) {
  if (!value) return "—";
  return new Intl.DateTimeFormat("fr-BE", includeTime
    ? { dateStyle: "short", timeStyle: "short" }
    : { dateStyle: "short" }
  ).format(new Date(value));
}
